import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';


@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent {
  submit = false;
  isSubmitted = false;
  myFormSubmit = false;
  token : any;
  email : any;
  successMessage: any = '';

  resetPasswordForm = new FormGroup({
    // old_password    : new FormControl ('',[Validators.required]),
    new_password    : new FormControl ('',[Validators.required]),
    re_new_password : new FormControl ('',[Validators.required]),
  });
  constructor(private fb: FormBuilder, private router: Router, public apiService: ApiServiceService, public shared: SharedService,private route: ActivatedRoute) {
    this.shared.isWhiteMenu = true
  }

  ngOnInit(){
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.email = params['email'];
    });
  }

  async onSubmit(){
    this.myFormSubmit=true;
    console.log(this.resetPasswordForm.value)
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.RESET_PASSWORD,
      {
        token : this.token,
        email : this.email,
        password : this.resetPasswordForm.value.new_password,
        confirm_password : this.resetPasswordForm.value.re_new_password,
      }
    );
    console.log("res", res);
    if (res && !res.error) {
      this.isSubmitted = true;
      this.successMessage = "Password Reset successfully!"
    }
  }
}
